import moment from 'moment';
import rangePlugin from 'flatpickr/dist/plugins/rangePlugin';
import { Arabic } from "flatpickr/dist/l10n/ar.js"
$( function() {

    var lang = $('html').attr('lang') == 'ar' ? Arabic : '';
    $('#switcher').on('click',function(e){

      e.preventDefault();
      var obj = { 
        "from" : $('#from').val(), 
        "to" : $('#to').val(),
        "fromId" : $('#from-id').val(), 
        "toId" : $('#to-id').val() 
      };
      $('#from').val(obj.to); 
      $('#to').val(obj.from); 
      $('#from-id').val(obj.toId); 
      $('#to-id').val(obj.fromId); 
    });

    $('.return').hide()
    
    if(getUrlParameter('trip_type') && getUrlParameter('trip_type') == 2){
      round_trip();
    }
    
    if((window.location.pathname == '/' && $("#one_way").is(":checked")) || (getUrlParameter('trip_type') && getUrlParameter('trip_type') == 1 && $("#one_way").is(":checked"))){
      $('.duration-wraper').flatpickr({
          altFormat: "j f Y",
          dateFormat: "Y-m-d",
          minDate: "today",
          disableMobile: "true",
          "locale": lang,
          wrap: true
      });
    }

    $(".trip-type").click(function () {
      round_trip();
    });

    if($(window).width() < 839){
      $( "#departure" ).focus(function() {
        $(this).next().hide();
      });
    }
    
    function round_trip(){
      var departure_date = $('#departure').val();
      console.log('clicked');
      console.log('condition 1 = ', $("#round_trip").is(":checked") && (getUrlParameter('trip_type') && getUrlParameter('trip_type') == 2));
      console.log('condition 2 = ', $("#round_trip").is(":checked"));
      if(($("#round_trip").is(":checked") && (getUrlParameter('trip_type') && getUrlParameter('trip_type') == 2)) || $("#round_trip").is(":checked")) {
        // $('#departure').datePicker({ minDate: 0, monthCount: 2, range: '#return' });
        $('.return').show()
        $('#departure').flatpickr({
          defaultDate: [departure_date, ''],
          minDate: "today",
          "plugins": [new rangePlugin({ input: "#return"})],
          disableMobile: "true",
          "locale": lang
        });
        $(".departure").removeClass("mdl-cell--12-col");
        $(".departure").addClass("mdl-cell--6-col rounded-r-none");
        $(".duration-wraper").removeClass("mdl-cell--3-col");
        $(".duration-wraper").addClass("mdl-cell--4-col");
        $(".passengers-wraper").removeClass("mdl-cell--3-col");
        $(".passengers-wraper").addClass("mdl-cell--2-col");
        $("#departure").addClass("w-full");
        if ( $('html').attr('lang') == 'ar' ) {
          $("#return").addClass("w-full -mr-1 rounded-l-none");
        } else {
          $("#return").addClass("w-full -ml-1 rounded-l-none");
        }
      }else{
        console.log('here');
        $('.duration-wraper').flatpickr({
          altFormat: "j f Y",
          dateFormat: "Y-m-d",
          minDate: "today",
          disableMobile: "true",
          "locale": lang,
          wrap: true
        });
        $('.return').hide()
        $(".departure").addClass("mdl-cell--12-col");
        $(".departure").removeClass("mdl-cell--6-col");
        $(".duration-wraper").addClass("mdl-cell--3-col");
        $(".duration-wraper").removeClass("mdl-cell--4-col");
        $(".passengers-wraper").addClass("mdl-cell--3-col");
        $(".passengers-wraper").removeClass("mdl-cell--2-col");
      }
    }

    $('body').on('change', '#departure', function(e){
      sessionStorage.setItem("daparture", JSON.stringify($(this).val()));
      sessionStorage.setItem("return", JSON.stringify($('#return').val()));
    })
    $('body').on('change', '#return', function(e){
      sessionStorage.setItem("return", JSON.stringify($(this).val()));
      sessionStorage.setItem("daparture", JSON.stringify($('#daparture').val()));
    })
    function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;
  
      for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');
  
          if (sParameterName[0] === sParam) {
              return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
          }
      }
    }

});
